"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
            flexDirection: 'row',
        },
        clickable: {
            cursor: 'pointer',
        },
        itemWrapper: function (_a) {
            var itemOffset = _a.itemOffset;
            return ({
                marginLeft: itemOffset,
                boxShadow: '0px 0px 0px 1px #FFF',
                borderRadius: '50%',
                overflow: 'hidden',
                '&:first-of-type': {
                    marginLeft: 0,
                },
            });
        },
        plusWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 24,
            minHeight: 24,
            marginLeft: -1,
            padding: '0 4px',
            zIndex: 1,
            boxShadow: 'none',
            '&:first-of-type': {
                marginLeft: 0,
            },
        },
    });
});
